module.exports = __webpack_public_path__ + "static/img/共享运营平台1.5112a1c0.png";